const RainShader = `
    precision mediump float;
    uniform vec2 iResolution;
    uniform float iTime;
    uniform float speed;
    uniform sampler2D uMainSampler;
    varying vec2 outTexCoord;

    const int LAYERS = 6;             // number of layers of drops
    const float SCALE = 128.0;        // overall scale of the drops
    const float LENGTH = 16.0;        // length of the drops
    const float LENGTH_SCALE = 0.8;   // how much the drop length changes every layer
    const float FADE = 0.6;           // how much the drops fade every layer
    const vec3 DROP_COLOR = vec3(0.90, 0.90, 0.94);
    const vec3 BG_COLOR = vec3(0.75, 0.75, 0.75);

    highp float rand(vec2 co)
    {
        highp float a = 12.9898;
        highp float b = 78.233;
        highp float c = 43758.5453;
        highp float dt = dot(co.xy, vec2(a, b));
        highp float sn = mod(dt, 3.14);
        return fract(sin(sn) * c);
    }

    float rainFactor(vec2 uv, float scale, float dripLength, vec2 offset, float cutoff)
    {
        vec2 pos = uv * vec2(scale, scale / dripLength) + offset;
        vec2 dripOffset = vec2(0, floor(rand(floor(pos * vec2(1, 0))) * (dripLength - 0.0001)) / dripLength);
        float f = rand(floor(pos + dripOffset));
        return step(cutoff, f);
    }

    vec4 over(vec4 a, vec4 b)
    {
        return vec4(mix(b, a, a.a).rgb, max(a.a, b.a));
    }

    void mainImage(out vec4 fragColor, in vec2 fragCoord)
    {
      vec4 startColor = texture2D(uMainSampler, outTexCoord);
        vec2 uv = fragCoord.xy / iResolution.xy;
        float aspect = iResolution.x / iResolution.y;
        uv.x *= aspect;

        vec4 finalColor = vec4(0);

        float dropLength = LENGTH;
        float alpha = 1.0;

        for (int i = 0; i < LAYERS; i++)
        {
            float f = rainFactor(uv, SCALE, dropLength, vec2(SCALE * float(i), iTime * speed), 0.95);
            vec4 color = vec4(DROP_COLOR, f * alpha);
            finalColor = over(finalColor, color);
            dropLength *= LENGTH_SCALE;
            alpha *= FADE;
        }

        finalColor = over(finalColor, vec4(BG_COLOR, 1.0));

        fragColor = vec4(finalColor.r, finalColor.g, finalColor.b, 1.) * startColor;
    }

    void main()
    {
        mainImage(gl_FragColor, gl_FragCoord.xy);
    }
`;

export class RainPipeline extends Phaser.Renderer.WebGL.Pipelines.SinglePipeline {
    constructor(
        game,
        speed = 8.0,
        ) {
        super({
            game,
            fragShader: RainShader,
            uniforms: ['iResolution', 'iTime', 'uMainSampler']
        });

        this.speed = speed;
    }

    onPreRender() {
        this.set2f('iResolution', 400, 200);
        this.set1f('iTime', this.game.loop.time / 700);
        this.set1f('speed', this.speed);
    }
}
